var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"overlay-cart__empty"},[_vm._v("\n  It looks like your cart is currently empty!\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }